// var env                                     = "dev-" // Dev
var env                                     = "" // Pro


// web
export const http                           = "https://"
export const head                           = http + env
export const homepage                       = head + "www.packhai.com/"
export const customerWebsite                = head + "customer.packhai.com/"
export const shopCallbackService            = head + "shop.packhai.com/platform/"
export const hostService                    = head + "service.packhai.com/"
export const packhaiApi88                   ="packhai-api-88.com/"

export const taobaoApi                      ="taobao2you.com/"

// service dotnet TaoBao
// export const taobaoService_dotnet           = head + "api." + taobaoApi
export const taobaoService_dotnet           = head + "dev-api." + taobaoApi

// service dotnet TaoBao localhost
// export const taobaoService_dotnet            = "https://localhost:5001/"
